import { create } from 'zustand';
import type { User } from '@wingman/shared';
import { api } from '../lib/api.js';

interface AuthState {
  user: User | null;
  loading: boolean;
  login: (email: string, password: string) => Promise<void>;
  register: (email: string, password: string, name: string) => Promise<void>;
  logout: () => void;
  setUser: (user: User | null) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  loading: false,

  login: async (email, password) => {
    set({ loading: true });
    try {
      const user = await api.auth.login(email, password);
      set({ user, loading: false });
    } catch (err) {
      set({ loading: false });
      throw err;
    }
  },

  register: async (email, password, name) => {
    set({ loading: true });
    try {
      const user = await api.auth.register(email, password, name);
      set({ user, loading: false });
    } catch (err) {
      set({ loading: false });
      throw err;
    }
  },

  logout: () => {
    api.auth.logout();
    set({ user: null });
  },

  setUser: (user) => set({ user }),
}));
